export default "__VITE_ASSET__BiE7FkJB__"